import { render, staticRenderFns } from "./ChecklistItem.vue?vue&type=template&id=6c107d5a&scoped=true&"
import script from "./ChecklistItem.vue?vue&type=script&lang=js&"
export * from "./ChecklistItem.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistItem.vue?vue&type=style&index=0&id=6c107d5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c107d5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
